<button
	type="button"
	class="toggle-switch"
	[class.toggle-switch--active]="active"
	[class.toggle-switch--disabled]="disabled"
	[attr.aria-checked]="active"
	[attr.aria-labelledby]="label || labelKey ? labelId : null"
	[disabled]="disabled"
	role="switch"
	(click)="toggle()"
>
	<span class="toggle-switch__control" aria-hidden="true">
		<span class="toggle-switch__control__thumb"></span>
	</span>

	<span *ngIf="label || labelKey" [id]="labelId" class="toggle-switch__label paragraph-medium">
		<ng-container *ngIf="label; else translatedLabelTpl">{{ label }}</ng-container>
		<ng-template #translatedLabelTpl>{{ labelKey | translate }}</ng-template>
	</span>
</button>
